import { render, staticRenderFns } from "./preview-sms.vue?vue&type=template&id=919ddd28&scoped=true"
import script from "./preview-sms.vue?vue&type=script&lang=js"
export * from "./preview-sms.vue?vue&type=script&lang=js"
import style0 from "./preview-sms.vue?vue&type=style&index=0&id=919ddd28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919ddd28",
  null
  
)

export default component.exports